// @flow
import * as React from 'react';

import { CountryName } from '@gandi/react-places';
import type { FavoriteContact } from '@gandi/redux-resource-contactbook';
import { Base } from '@gandi/ui';

type Props = {
  contact: FavoriteContact,
};

const ContactAddress = ({
  contact: { streetaddr, zip, city, country, phone, fax },
}: Props): React.MixedElement => (
  <Base tagName="p" marginY="none">
    {streetaddr}
    <br />
    {zip} {city}
    <br />
    <CountryName country={country} />
    <br />
    {phone}
    <br />
    {fax}
  </Base>
);

export default (React.memo<Props>(ContactAddress): React.ComponentType<Props>);
